import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs"

export const quizDetailsApi = createAsyncThunk(
    'auth/quiz/detail',
    async (id, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.get(apiRoutes.quizAction(`${id}`, 0))
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)
const intialState = { result: {}, loading: false, error: null, message: "" }
const quizDetailsSlice = createSlice({
    name: 'quiz detail',
    initialState: { result: {}, loading: false, error: null, message: "" },
    reducers: {
        resetQuiz: () => intialState,
    },
    extraReducers: (builder) => {
        builder.addCase(quizDetailsApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(quizDetailsApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result
            state.message = action?.payload?.message
        })
        builder.addCase(quizDetailsApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})
export const { resetQuiz } = quizDetailsSlice.actions;
export const quizDetailsReducer = quizDetailsSlice.reducer